import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";
import { Integration } from "@/models/integration";

class IntegrationService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt,
      }
    });
  }

  async getIntegrations(groups: any): Promise<AxiosResponse<Integration[]>> {
    return await this.client.get("/integrations?groups=" + groups);
  }

}

export default IntegrationService;
